import React, {useState, useEffect, useRef} from 'react';
import { Button, Card, CardText, Carousel} from 'react-bootstrap';
import AuthService from "../utils/auth";
import { useNavigate } from "react-router-dom";


function InvestorProfile() {
  const authUser = AuthService.loggedIn();  
  const userId = authUser.userId;
  const currentUser = AuthService.loggedIn(); 
  const [crewmember, setCrewmember] = useState(userId); 
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [originalData, setOriginalData] = useState({}); 
  const [isEditing, setIsEditing] = useState(false);
  const [profilePreviews, setProfilePreviews] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [profileIError, setProfileIError] = useState("");
  const navigate = useNavigate();



const [cardVisible, setCardVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCardVisible(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  

  const [formState, setFormState] = useState({ 
    userId: '',
    email: '', 
    crewmember: '',
    position: [],
    profileI: [],  
   });


  useEffect(() => {
    // console.log("userId extracted from URL:", userId); 
    const fetchCrewData = async () => {
      try {
        const token = AuthService.getToken(); 
         const response = await fetch(`https://bkf.onrender.com/investors/${authUser.userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
        if (!response.ok) {
          throw new Error('Failed to fetch crew data');
        }
        const data = await response.json();
        setFormState(data); 
        setIsLoaded(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message);
      }
    };
    
    fetchCrewData();
  }, [userId]);





  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  // console.log('Preparing to send form data')
  
  const handleSaveChanges = async () => {  



    if (!formState.crewmember|| formState.crewmember.trim() === "") {
      console.log("Validation failed: position");
      setNameError("Name Required");
      return; 
    }

    if (!formState.email|| formState.email.trim() === "") {
      console.log("Validation failed: position");
      setEmailError("Email Required");
      return; 
    }
  
    setNameError(""); 

    setProfileIError(""); 
   

    const formData = new FormData();
  
    formData.append('email', formState.email);
  
    if (Array.isArray(formState.position)) {
      formState.position.forEach(pos => formData.append('position', pos));
    } else {
      formData.append('position', formState.position);
    }

    if (Array.isArray(formState.profileI) && formState.profileI.length > 0) {
      formState.profileI.forEach((file, index) => {
        formData.append(`profileI[${index}]`, file);
      });
    }

    if (formState.crewmember) {
      formData.append('crewmember', formState.crewmember);
    }

    
    try {
      const response = await fetch(`https://bkf.onrender.com/investors/${userId}`, {
        method: 'PUT',
        body: formData,
      });

      if (response.ok) {
        setFormState(formState);
        setIsEditing(false);
      } else {
        console.error("Failed to save changes");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };



const handleAddImage = (event) => {
  const newFiles = Array.from(event.target.files).slice(0, 1); // only one image

  // Update form state with the uploaded file
  setFormState(prev => ({
    ...prev,
    profileI: newFiles.length > 0 ? newFiles : prev.profileI,
  }));

  // Update preview only if a file was uploaded
  setProfilePreviews(
    newFiles.length > 0
      ? newFiles.map(file => URL.createObjectURL(file))
      : formState.profileI && formState.profileI.length > 0
        ? formState.profileI.map(img => (img instanceof File ? URL.createObjectURL(img) : img))
        : [] // no placeholder, empty array if nothing uploaded
  );
};



  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
  
    handleResize();
    window.addEventListener('resize', handleResize);
  
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  

const canEdit = currentUser && currentUser.userId === userId;

if (currentUser.userId.toString() !== userId.toString()) {
  return <div style={{ padding: "20px", color: "red" }}>
    Unauthorized: You do not have permission to view this profile.
  </div>;
}


  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!isLoaded) {
    return <div 
                  style={{ 
                    height:"100vh",
                    marginTop: "30%",
                    marginRight: "25%",
                    marginLeft: "25%" 
                    }}>
                      <Card className="card-body"
                       style={{ 
                    textAlign: "center", 
                    }}
                      >
                        <h1>Loading...</h1>
                      </Card>
                  </div>;
  }





    const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  return (
    <div
     style={{
          marginTop: '10%',  
        }}
    >
      <>
          <>

                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1,
                      }}
                        >
                          <source 
                        src={`${CF_BASE}/public/backgroundgrey2.mp4`} 
                          />
                          Your browser does not support the video tag.
                        </video>
      <div 
      style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        }}>
              <div>
                <div className="row align-items-center" style={{ backgroundColor: 'black' }}></div>
                <div>
                <h1 className='justify-content-center'
               style={{
          // marginTop: '50px',
           WebkitTextStroke: '2px rgb(243, 174, 61)', // <-- outline around letters
            color: 'black', 
        }}
                >
            {isEditing ? (
              <> 
              <input className="about-card-edit"
              style={{
                background: 'none',
                border: 'none',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'silver',
                caretColor: 'grey',
                width: '90%',
                
              }}
                type="text"
                name="crewmember"
                value={formState.crewmember || ''}
                onChange={handleInputChange}
              />
              
              <CardText>
              {nameError && nameError}
              </CardText>
              </>
            ) : (  
              <div> 
                {formState && formState.crewmember}
            </div>
            )}
           </h1>
          </div>
          
                                
                
{formState && (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginBottom: '5%',
      width: '100%',
    }}
  >
    <div style={{ position: 'relative' }}>
      {/* Only render image if user uploaded one */}
      {formState.profileI && formState.profileI[0] && (
        <Card.Img
          src={
            formState.profileI[0] instanceof File
              ? URL.createObjectURL(formState.profileI[0])
              : formState.profileI[0]
          }
          alt="crew image"
          className="img-fluid"
          style={{
            width: '300px',
            height: 'auto',
            maskImage: 'linear-gradient(to right, transparent, white 20%, white 80%, transparent)',
            WebkitMaskImage: 'linear-gradient(to right, transparent, white 20%, white 80%, transparent)',
            transition: 'mask-image 0.3s ease',
            display: 'block',
          }}
        />
      )}

      {/* Add Image button */}
      {isEditing && (
        <>
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            id="profileIInput"
            onChange={handleAddImage}
          />
          <Button
            className="process-card-text hover-brighten"
            onClick={() => document.getElementById('profileIInput').click()}
             style={{
                  display: 'block',
                  height: '40%',
                  width: 'auto',
                  margin: '10px auto',
                  fontSize: '2.5vmin',
                  backgroundColor: 'rgb(67, 66, 66)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
          >
            <h2 style={{ margin: '1%' }}>Replace Image</h2>
          </Button>
        </>
      )}
    </div>


          </div>
        )}



                <div>
              </div>

           <Card 
                  
                  style={{
                    display: 'block',
                    // marginRight: '15%',
                    // marginLeft: '10%',
                    marginBottom: '2%',
                    width: 'auto',
                    height: 'auto',
                    boxSizing: 'border-box',
                  }}>

                <div className="row gy-4">
                  
                 {isEditing ? (
                    <>
                    <div className="col-12 col-md-12 col-lg-12 d-flex flex-column align-items-start">
                      <h3 className="mb-2" style={{ margin: '1%' }}>Email</h3>
                      <div style={{ position: 'relative', width: '100%', }}>
                      <input
                        className="form-control about-card-edit"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'silver',
                          caretColor: 'grey',
                          width: '100%',
                          fontSize: '1.2rem',
                        }}
                        type="text"
                        name="email"
                        value={formState.email || ''}
                        onChange={handleInputChange}
                      />
                      <CardText>
                       {emailError && emailError}
                      </CardText>
                      </div>
                      </div>
               
                    </>
                  ) : (
                    <>
                <div className="col d-flex flex-column justify-content-center align-items-center">

                </div>
                    </>
                )}

                  </div>

              </Card>
            </div>
            </div>
          </>
       </>
       
      {AuthService.loggedIn() && (
          <Card
          className="p-4 "
          style={{
          //  marginTop: '5%',
           marginBottom: '5%',
           marginRight: '25%',
           marginLeft: '25%',
           width: 'auto',       
           display: 'block',  
           overflow: 'hidden',
           boxSizing: 'border-box', 
         }}>
        <div className="row gy-4">
          {isEditing && (
            <>
            <div className='col col-md-6 col-lg-6 d-flex flex-column'>
            <Button 
              className="process-card-text hover-brighten"
              style={{
                display: 'block',
                height: 'auto',
                width: 'auto',
                margin: '5px auto',
                fontSize: '2.5vmin',
                backgroundColor: 'rgb(0, 128, 0)',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
              onClick={handleSaveChanges}
              >
              <h2 style={{ margin: '1%' }}>Save</h2>
            </Button>
            </div>
            </>
            
          
          )}
          {canEdit && (
            <>
            <div className={`col d-flex flex-column ${!isEditing ? 'col-12' : 'col-md-6 col-lg-6'}`}>
            <Button
              className="process-card-text hover-brighten"
              style={{
                display: 'block',
                height: 'auto',
                width: 'auto',
                margin: '5px auto',
                fontSize: '2.5vmin',
                backgroundColor: !isEditing ? 'rgb(67, 66, 66)': 'red',
                color: !isEditing ? 'silver': '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
              onClick={() => {
                if (isEditing) {
                  
                  setFormState(originalData); 
                } else {
                  setOriginalData(formState);
                }
                setIsEditing((prev) => !prev); 
              }}
              disabled={!canEdit}
            >
              <h2 style={{ margin: '1%' }}>
                {isEditing ? 'Cancel' : 'Edit Profile'}
              </h2>
            </Button>
            </div>
            </>
          )}
        </div>
        </Card>
      )}  

  </div>
 );

}

export default InvestorProfile;